export function resolvePathFromObject(object, objectPathMap) {
    let current = object;
    while (current) {
        const path = objectPathMap.get(current);
        if (path !== undefined)
            return path;
        current = current.parent;
    }
    return null;
}
//# sourceMappingURL=resolvePathFromObject.js.map